var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Mixins, Watch, Prop } from 'vue-property-decorator';
import CrudSidesheetMixin from '@/mixins/crud-sidesheet-mixin';
import BaseCrudSidesheet from '@/components/base/BaseCrudSidesheet.vue';
import ItemsMixin from '@/mixins/items-mixin';
import { lazyInject } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
import { UpMarketLoadConfigService } from '@/services/opportunity-management/opportunity-upmarketloadconfig-service';
import { MaterialService } from '@/services/material-management/material-service';
import { VendorService } from '@/services/vendor-service';
import { SiteService } from '@/services/site-management/site-service';
import { CarrierService } from '@/services/carrier-management/carrier-service';
import SnackbarMixin from '@/mixins/snackbar-mixin';
import UtilsMixin from '@/mixins/utils-mixin';
import { mask } from 'vue-the-mask';
var CrudSidesheet = /** @class */ (function (_super) {
    __extends(CrudSidesheet, _super);
    function CrudSidesheet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.disabledVendor = false;
        _this.options = {
            sites: [],
            materials: [],
            fromTimeWindows: [],
            toTimeWindows: [],
            sourceTypes: [],
            vendors: [],
            carriers: [],
        };
        _this.opportunityUpMarketLoadConfigVm = [];
        return _this;
    }
    CrudSidesheet.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.sidesheetLoading = true;
                        // get reference data
                        return [4 /*yield*/, this.lazyLoadReferenceData()];
                    case 1:
                        // get reference data
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        this.showSnackbar({ text: 'Unable to load data', color: 'error' });
                        return [3 /*break*/, 4];
                    case 3:
                        this.sidesheetLoading = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CrudSidesheet.prototype.lazyLoadReferenceData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, _d, referenceDataResponse;
            var _this = this;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this.options;
                        return [4 /*yield*/, this.siteService.getAllRef()];
                    case 1:
                        _a.sites = (_e.sent()).data;
                        // diesel only
                        _b = this.options;
                        return [4 /*yield*/, this.vendorService.getAllRef()];
                    case 2:
                        // diesel only
                        _b.vendors = (_e.sent()).data;
                        _c = this.options;
                        return [4 /*yield*/, this.materialService.getAll(false)];
                    case 3:
                        _c.materials = (_e.sent()).data.filter(function (item) { return item.materialGroupId === _this.dieselMaterialGroupId; });
                        _d = this.options;
                        return [4 /*yield*/, this.referenceDataService.get('/carrier/getdispatchdesks')];
                    case 4:
                        _d.carriers = _e.sent();
                        return [4 /*yield*/, this.referenceDataService.getModulesByRequest({ modules: [
                                    'VOYAGE_WINDOWS',
                                    'LOAD_SOURCE_TYPES',
                                ], includeDeleted: false })];
                    case 5:
                        referenceDataResponse = _e.sent();
                        this.options.fromTimeWindows = referenceDataResponse.success ? referenceDataResponse.data.filter(function (item) { return item.module === 'VOYAGE_WINDOWS'; }) : [];
                        this.options.toTimeWindows = referenceDataResponse.success ? referenceDataResponse.data.filter(function (item) { return item.module === 'VOYAGE_WINDOWS'; }) : [];
                        this.options.sourceTypes = referenceDataResponse.success ? referenceDataResponse.data.filter(function (item) { return item.module === 'LOAD_SOURCE_TYPES'; }) : [];
                        return [2 /*return*/];
                }
            });
        });
    };
    CrudSidesheet.prototype.creating = function () {
        return __awaiter(this, void 0, void 0, function () {
            var autoCloseSidesheet, data, response, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        autoCloseSidesheet = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        data = __assign({}, this.selectedItem);
                        // validate end is after start
                        if (+data.timeWindowEnd <= +data.timeWindowStart) {
                            this.showSnackbar({
                                text: 'Time Window End time must be after Time Window Start Time',
                                color: 'error',
                            });
                            autoCloseSidesheet = false;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.upMarketLoadConfigService.createUpMarketLoadConfig(data)];
                    case 2:
                        response = _a.sent();
                        if (response.success === false) {
                            this.showSnackbar({ text: response.message, color: 'error' });
                            return [2 /*return*/];
                        }
                        this.showSnackbar({
                            text: 'Up market load config created',
                            color: 'success',
                        });
                        this.$emit('saved', data);
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _a.sent();
                        console.error(error_2);
                        this.showSnackbar({
                            text: 'Unable to create Up market load config',
                            color: 'error',
                        });
                        // send back to parent
                        this.$emit('saved', null);
                        return [3 /*break*/, 5];
                    case 4:
                        if (autoCloseSidesheet) {
                            this.close();
                        }
                        this.sidesheetLoading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CrudSidesheet.prototype.updating = function () {
        return __awaiter(this, void 0, void 0, function () {
            var autoCloseSidesheet, data, response, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        autoCloseSidesheet = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        data = __assign({}, this.selectedItem);
                        // validate end is after start
                        if (+data.timeWindowEnd <= +data.timeWindowStart) {
                            this.showSnackbar({
                                text: 'Time Window End time must be after Time Window Start Time',
                                color: 'error',
                            });
                            autoCloseSidesheet = false;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.upMarketLoadConfigService.updateUpMarketLoadConfig(data)];
                    case 2:
                        response = _a.sent();
                        if (response.success === false) {
                            this.showSnackbar({ text: response.message, color: 'error' });
                            return [2 /*return*/];
                        }
                        this.showSnackbar({
                            text: 'Up market load config updated',
                            color: 'success',
                        });
                        this.$emit('updated', data);
                        return [3 /*break*/, 5];
                    case 3:
                        error_3 = _a.sent();
                        console.error(error_3);
                        this.showSnackbar({
                            text: 'Unable to update Up market load config',
                            color: 'error',
                        });
                        // send back to parent
                        this.$emit('updated', null);
                        return [3 /*break*/, 5];
                    case 4:
                        if (autoCloseSidesheet) {
                            this.close();
                        }
                        this.sidesheetLoading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    CrudSidesheet.prototype.onItemChanged = function (val, oldVal) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(val !== oldVal)) return [3 /*break*/, 2];
                        data = this.selectedItem;
                        // reset the available vendors based on data
                        return [4 /*yield*/, this.updateAvailableVendors(data.sourceType, data.siteId, data.materialId)];
                    case 1:
                        // reset the available vendors based on data
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    CrudSidesheet.prototype.onSiteUpdated = function (siteId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = this.selectedItem;
                        return [4 /*yield*/, this.updateDefaultCarrier(siteId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.updateDefaultLoadSize(siteId, null)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.updateAvailableVendors(data.sourceType, siteId, data.materialId)];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.updateAvailableMaterials(siteId)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CrudSidesheet.prototype.onMaterialUpdated = function (materialId) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = this.selectedItem;
                        return [4 /*yield*/, this.updateDefaultLoadSize(null, materialId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.updateAvailableVendors(data.sourceType, data.siteId, materialId)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CrudSidesheet.prototype.onSourceTypeUpdated = function (sourceType) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = this.selectedItem;
                        return [4 /*yield*/, this.updateAvailableVendors(sourceType, data.siteId, data.materialId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CrudSidesheet.prototype.updateDefaultCarrier = function (siteId) {
        return __awaiter(this, void 0, void 0, function () {
            var data, defaultCarrier;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = __assign({}, this.selectedItem);
                        // update the site id
                        data.siteId = siteId;
                        // do not update load size if no site
                        if (!data.siteId || data.siteId.length === 0) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.carrierService.getDefaultDispatchDesk(siteId, this.dieselMaterialGroupId)];
                    case 1:
                        defaultCarrier = (_a.sent()).data;
                        data.carrierId = defaultCarrier.id;
                        this.selectedItem = data;
                        return [2 /*return*/];
                }
            });
        });
    };
    CrudSidesheet.prototype.updateDefaultLoadSize = function (siteId, materialId) {
        return __awaiter(this, void 0, void 0, function () {
            var data, materialTypeId, defaultLoadSize;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = __assign({}, this.selectedItem);
                        // update the site id and material id
                        data.siteId = siteId || data.siteId;
                        data.materialId = materialId || data.materialId;
                        // do not update load size if no site or material
                        if (!data.siteId || data.siteId.length === 0 || !data.materialId || data.materialId.length === 0) {
                            return [2 /*return*/];
                        }
                        materialTypeId = this.options.materials.find(function (item) { return item.materialId === data.materialId; }).materialTypeId;
                        return [4 /*yield*/, this.siteService.getDefaultLoadSizeBySiteAndMaterial(data.siteId, materialTypeId)];
                    case 1:
                        defaultLoadSize = (_a.sent()).data;
                        data.loadSize = defaultLoadSize;
                        this.selectedItem = data;
                        return [2 /*return*/];
                }
            });
        });
    };
    CrudSidesheet.prototype.updateAvailableVendors = function (sourceType, siteId, materialId) {
        return __awaiter(this, void 0, void 0, function () {
            var data, availableVendors, matchingVendor;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = __assign({}, this.selectedItem);
                        return [4 /*yield*/, this.vendorService.getRefBySiteIdSourceTypeMaterialId(siteId, sourceType, materialId)];
                    case 1:
                        availableVendors = _a.sent();
                        // update the data
                        data.sourceType = sourceType;
                        data.siteId = siteId;
                        data.materialId = materialId;
                        // if no site Id then return early
                        if (!data.siteId) {
                            this.options.vendors = availableVendors;
                            return [2 /*return*/];
                        }
                        if (data.sourceType === this.contractSourceType || data.sourceType === this.manualSourceType) {
                            this.disabledVendor = false;
                        }
                        else {
                            this.disabledVendor = true;
                        }
                        matchingVendor = availableVendors.filter(function (item) { return item.vendorId === data.vendorId; });
                        if (matchingVendor.length === 0) {
                            data.vendorId = '';
                            this.selectedItem = data;
                        }
                        // update the available vendors
                        this.options.vendors = availableVendors;
                        return [2 /*return*/];
                }
            });
        });
    };
    CrudSidesheet.prototype.updateAvailableMaterials = function (siteId) {
        return __awaiter(this, void 0, void 0, function () {
            var data, availableVendors, _a, _b;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        data = __assign({}, this.selectedItem);
                        availableVendors = [];
                        data.siteId = siteId || data.siteId;
                        if (!!data.siteId) return [3 /*break*/, 2];
                        _a = this.options;
                        return [4 /*yield*/, this.materialService.getAll(false)];
                    case 1:
                        _a.materials = (_c.sent()).data.filter(function (item) { return item.materialGroupId === _this.dieselMaterialGroupId; });
                        return [2 /*return*/];
                    case 2:
                        // update the available materials
                        _b = this.options;
                        return [4 /*yield*/, this.materialService.getBySiteMaterialGroup(data.siteId, this.dieselMaterialGroupId)];
                    case 3:
                        // update the available materials
                        _b.materials = (_c.sent()).data;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CrudSidesheet.prototype, "vendorValidationRule", {
        get: function () {
            var data = this.selectedItem;
            return data.sourceType === this.manualSourceType || data.sourceType === this.contractSourceType
                ? { required: true }
                : {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrudSidesheet.prototype, "contractSourceType", {
        get: function () {
            return 'CONTRACT';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrudSidesheet.prototype, "manualSourceType", {
        get: function () {
            return 'MANUAL';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CrudSidesheet.prototype, "dieselMaterialGroupId", {
        get: function () {
            return 'D';
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b, _c, _d, _e;
    __decorate([
        lazyInject(TYPES.UpMarketLoadConfigService),
        __metadata("design:type", typeof (_a = typeof UpMarketLoadConfigService !== "undefined" && UpMarketLoadConfigService) === "function" ? _a : Object)
    ], CrudSidesheet.prototype, "upMarketLoadConfigService", void 0);
    __decorate([
        lazyInject(TYPES.MaterialService),
        __metadata("design:type", typeof (_b = typeof MaterialService !== "undefined" && MaterialService) === "function" ? _b : Object)
    ], CrudSidesheet.prototype, "materialService", void 0);
    __decorate([
        lazyInject(TYPES.VendorService),
        __metadata("design:type", typeof (_c = typeof VendorService !== "undefined" && VendorService) === "function" ? _c : Object)
    ], CrudSidesheet.prototype, "vendorService", void 0);
    __decorate([
        lazyInject(TYPES.SiteService),
        __metadata("design:type", typeof (_d = typeof SiteService !== "undefined" && SiteService) === "function" ? _d : Object)
    ], CrudSidesheet.prototype, "siteService", void 0);
    __decorate([
        lazyInject(TYPES.CarrierService),
        __metadata("design:type", typeof (_e = typeof CarrierService !== "undefined" && CarrierService) === "function" ? _e : Object)
    ], CrudSidesheet.prototype, "carrierService", void 0);
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], CrudSidesheet.prototype, "defaultName", void 0);
    __decorate([
        Watch('selectedItem.oppUpVoyId', { immediate: false, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", Promise)
    ], CrudSidesheet.prototype, "onItemChanged", null);
    CrudSidesheet = __decorate([
        Component({
            components: {
                'base-crud-sidesheet': BaseCrudSidesheet,
            },
            directives: {
                mask: mask,
            },
        })
    ], CrudSidesheet);
    return CrudSidesheet;
}(Mixins(CrudSidesheetMixin, ItemsMixin, SnackbarMixin, UtilsMixin)));
export default CrudSidesheet;
